import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { EventDefaultsSettings } from "@/components/app/event-defaults-settings";
import { OrgIdentitySettings } from "@/components/app/org-identity-settings";
import { QrCodeBlock } from "@/components/app/qr-code-block";
import { VOLUNTEER_LANDING_URL } from "@/lib/share-channels";

const description =
  "Set the fallback internal and public contact details used when events are created without them.";

export const Route = createFileRoute("/_authenticated/t1dwpanel/settings")({
  head: () => ({
    meta: [
      { title: "Event defaults | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Event defaults | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <AppShell title="Event defaults" eyebrow="Admin">
      <div className="space-y-6">
        <EventDefaultsSettings />
        <OrgIdentitySettings />
        <section className="panel p-6">
          <h2 className="t-h3 text-ice">General volunteer QR code</h2>
          <p className="t-body mt-2 text-sm">
            Points at the volunteer landing page with no referral attached. Use it for tabling
            signs, print materials, and anything shared from the T1D Warriors account.
          </p>
          <div className="mt-4">
            <QrCodeBlock
              url={VOLUNTEER_LANDING_URL}
              shortCode="general"
              heading="Volunteer landing QR code"
              fileBaseName="t1d-warriors-volunteer"
              printTitle="Volunteer with T1D Warriors"
              printSubtitle="Burlington, Kentucky. Remote outreach or on-site crew."
            />
          </div>
        </section>
      </div>
    </AppShell>
  );
}
